import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Link } from "react-router-dom";


const Privacy = () => {
  return (
    <div className="min-h-screen bg-slate-50" data-testid="privacy-page">
      <section className="py-16 lg:py-24 bg-white border-b">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Back to Home */}
          <Link to="/" className="inline-flex items-center text-emerald-600 hover:text-emerald-700 mb-6 text-sm font-medium">
            ← Back to Home
          </Link>
          
          <Badge className="bg-slate-100 text-slate-700 mb-4">Legal</Badge>
          <h1 className="text-4xl font-heading font-bold text-navy-700 mb-4">
            Privacy Policy
          </h1>
          <p className="text-slate-500">Last updated: January 2025</p>
        </div>
      </section>

      <section className="py-12">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <Card className="border-0 shadow-card">
            <CardContent className="prose prose-slate max-w-none p-8">
              <h2>1. Information We Collect</h2>
              <p>
                We collect information you provide directly to us, such as when
                you create an account, subscribe to our newsletter, register for
                a seminar, or complete a survey.
              </p>
              <ul>
                <li>
                  <strong>Personal Information:</strong> Name, email address,
                  phone number
                </li>
                <li>
                  <strong>Survey Responses:</strong> Your answers to our
                  investment barrier survey
                </li>
                <li>
                  <strong>Usage Data:</strong> How you interact with our website
                </li>
              </ul>

              <h2>2. How We Use Your Information</h2>
              <p>We use the information we collect to:</p>
              <ul>
                <li>Send you educational content and newsletters</li>
                <li>Notify you about seminars and events</li>
                <li>Provide personalized investment education resources</li>
                <li>Improve our services and content</li>
                <li>Communicate with you about our services</li>
              </ul>

              <h2>3. SMS Communications</h2>
              <p>
                If you opt in to receive SMS messages, you agree to receive text
                messages from Compoundr about seminars, events, and
                educational content. Message and data rates may apply. Reply
                STOP to unsubscribe at any time.
              </p>

              <h2>4. Information Sharing</h2>
              <p>
                We do not sell, trade, or otherwise transfer your personal
                information to third parties. We may share information with
                service providers who assist us in operating our website and
                conducting our business.
              </p>

              <h2>5. Data Security</h2>
              <p>
                We implement appropriate security measures to protect your
                personal information. However, no method of transmission over
                the Internet is 100% secure.
              </p>

              <h2>6. Your Rights</h2>
              <p>You have the right to:</p>
              <ul>
                <li>Access your personal data</li>
                <li>Request correction of your data</li>
                <li>Request deletion of your data</li>
                <li>Opt out of marketing communications</li>
              </ul>

              <h2>7. Contact Us</h2>
              <p>
                If you have questions about this Privacy Policy, please contact
                us at hello@newinvestors.ca.
              </p>
            </CardContent>
          </Card>
        </div>
      </section>

      
    </div>
  );
};

export default Privacy;
